/**
 * MXlab — Child collections band: previous/next buttons on desktop.
 *
 * The buttons show only while the row overflows. Each one is disabled at its end of the
 * row; the row's own `scroll` event and a ResizeObserver keep that in sync. On mobile,
 * CSS hides them. Smooth scrolling comes from the row's CSS `scroll-behavior`, so reduced
 * motion is handled there.
 */
class MxChildCollections extends HTMLElement {
  connectedCallback() {
    this.row = this.querySelector('[data-mx-cc-row]');
    this.controls = this.querySelector('[data-mx-cc-controls]');
    this.prev = this.querySelector('[data-mx-cc-prev]');
    this.next = this.querySelector('[data-mx-cc-next]');

    this.update = () => {
      const max = this.row.scrollWidth - this.row.clientWidth;
      // 1px tolerance: scrollLeft can be fractional on zoomed or high-density screens.
      const atStart = this.row.scrollLeft <= 1;
      const atEnd = this.row.scrollLeft >= max - 1;

      const focused = document.activeElement;

      this.controls.hidden = max <= 1;
      this.prev.disabled = atStart;
      this.next.disabled = atEnd;
      // A disabled button loses focus: hand it to the other one. This runs after the
      // states are set because focus() does nothing on a still-disabled button.
      if (atStart && focused === this.prev) this.next.focus();
      if (atEnd && focused === this.next) this.prev.focus();
    };

    this.prev.addEventListener('click', () => this.row.scrollBy({ left: -this.row.clientWidth }));
    this.next.addEventListener('click', () => this.row.scrollBy({ left: this.row.clientWidth }));
    this.row.addEventListener('scroll', this.update, { passive: true });

    this.observer = new ResizeObserver(this.update);
    this.observer.observe(this.row);
  }

  disconnectedCallback() {
    this.observer.disconnect();
  }
}

if (!customElements.get('mx-child-collections')) {
  customElements.define('mx-child-collections', MxChildCollections);
}
